exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes UserForm_fadeIn__VJmfn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes UserForm_fadeIn__VJmfn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes UserForm_fadeOut__1g299 {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes UserForm_fadeOut__1g299 {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.UserForm_userForm__W57Jo {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  width: 1000px;\n  min-width: 700px; }\n  .UserForm_userForm__W57Jo .UserForm_paper__n4zJp {\n    padding: 16px 24px 26px 24px;\n    box-sizing: border-box;\n    margin-bottom: 16px; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"userForm": "UserForm_userForm__W57Jo",
	"paper": "UserForm_paper__n4zJp",
	"fadeIn": "UserForm_fadeIn__VJmfn",
	"fadeOut": "UserForm_fadeOut__1g299"
};